import { useTranslation } from 'react-i18next';
import { selectedRoadSectionsQuery } from '../../../../../core/reference/queries';
import { useAppDispatch, useAppSelector } from '../../../../../types';
import { useEffect, useState } from 'react';
import { ContentContainer, ModalTitle } from '../../../../legacy/components/ui/modals/styles';
import GenericModal from '../../../../legacy/components/ui/modals/GenericModal';
import { ReferenceModalTypes } from '../../../../../core/legacy/reducers/modals';
import { Input } from '../../../../session/list-sessions/styles';
import editRoadSections from '../../../../../core/reference/commands/EditRoadSections';

const EditRoadSectionTraficPLModal = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const checkedRoadSections = useAppSelector(selectedRoadSectionsQuery);
    const checkedRoadSectionsIds = checkedRoadSections.map((s) => s.id);

    const [traficPL, setTrafficPL] = useState('');

    useEffect(() => {
        const traficPLs = checkedRoadSections
            .map((rs) => rs.trucks)
            .filter((n) => n !== undefined)
            .reduce((acc, val) => acc.add(val!), new Set<string>());
        if (traficPLs.size === 1) {
            setTrafficPL(traficPLs.values().next().value as string);
        } else {
            setTrafficPL('');
        }
    }, [checkedRoadSections]);

    const onValidate = () => {
        dispatch(
            editRoadSections({
                roadSectionData: {
                    trucks: traficPL,
                },
                roadSectionIds: checkedRoadSectionsIds,
            }),
        );
        setTrafficPL('');
    };

    const handleKeyDown = ({ key }: KeyboardEvent) => {
        if (key === 'Enter') {
            onValidate();
        }
    };

    return (
        <GenericModal
            onValidate={onValidate}
            modalType={ReferenceModalTypes.ROAD_SECTION_EDIT_TRAFIC_PL}
            options={{ notDismissableByClickingOnBackground: true }}
        >
            <ContentContainer>
                <ModalTitle>{t('reference.modals.editTraficPL')}</ModalTitle>
                <Input
                    onKeyDown={handleKeyDown}
                    value={traficPL}
                    type="text"
                    onChange={(e) => setTrafficPL(e.target.value)}
                    autoFocus
                />
            </ContentContainer>
        </GenericModal>
    );
};

export default EditRoadSectionTraficPLModal;
